import { trackPurchaseClick } from '../services/gtmService';

const PricingButton = ({ plan }) => {
  const handleClick = () => {
    // GTM: Track purchase click
    trackPurchaseClick(plan.name, plan.price, plan.link);
    window.open(plan.link, '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full py-3 px-6 rounded-lg font-semibold transition-all duration-300 ${
        plan.popular
          ? 'bg-gradient-to-r from-orange-600 to-orange-500 text-white hover:from-orange-700 hover:to-orange-600 shadow-md hover:shadow-lg'
          : 'bg-gray-800 text-white hover:bg-gray-900'
      }`}
    >
      Get Started
    </button>
  );
};

export default PricingButton;